document.addEventListener('DOMContentLoaded', function () {

  //Function to get product details
  function getProductDetails() {
    var  productData ="";


    if (typeof window.SwymProductInfo !== 'undefined') {
       var productData = {
          id:  window.SwymProductInfo.product.id ,
          title: window.SwymProductInfo.product.title,
          price: window.SwymProductInfo.product.price,


       };
     }

     return productData;

  }
  // Function to get user details
  function getUserDetails() {
    var  user ="";
    if (typeof  window.StatusInitData !== 'undefined') {
         user = {
         customer : window.StatusInitData
        };
    }


    return user;
  }



  //addto cart details
  function fetchCartDetails() {

    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const queryParams = new URLSearchParams(window.location.search);
        var nostoVal = queryParams.get('nosto');
        var obj = {
           nostoVal:nostoVal,
           product:getProductDetails(),
           user:getUserDetails(),
           domain:window.location.hostname,
           currency: window.theme.shopCurrency,
           currenttime: new Date(),
           cart:cart
        };
        sendProductDetails(obj);

      })

      .catch(error => console.error('Error fetching cart details:', error));
  }

  /*************************capture details*******************************/
  var url = window.location.href;
  var queryString = window.location.search;
  if(url!='' && queryString!='')
  {

   const queryParams = new URLSearchParams(window.location.search);
   if(queryParams.has('nosto'))
   {
     var nostoVal = queryParams.get('nosto');
     var obj = {
       nostoVal:nostoVal,
       product:getProductDetails(),
       user:getUserDetails(),
       currency: window.theme.shopCurrency,
       domain:window.location.hostname,
       currenttime: new Date()

     };

     sendProductDetails(obj);

       //addtocart
      document.querySelectorAll('.product__add-to-cart').forEach(button => {
        button.addEventListener('click', function() {
          sessionStorage.setItem("add_to_cart", "true");
          setTimeout(fetchCartDetails, 1000); // Adjust the delay as needed
        });
      });

    }

  }

});
// Function to send product details to your server
function sendProductDetails(product) {

    const url = "https://app.lateshipment.com/nosto/index.php";
    fetch(url, {
        method : "POST",
        body : JSON.stringify({ product: product })
    }).then(
        response => response.text() // .json(), etc.
    ).then(function() {
       response => response.text()
    });

}